import { createPortal as a } from "../../external/preact/compat/dist/compat.module.js";
import { useState as c, useMemo as i } from "../../external/preact/hooks/dist/hooks.module.js";
import m from "../useReflex.js";
const R = (r, n) => {
  const [t, s] = c(), d = m(
    i(() => {
      const u = (e) => (...f) => {
        const o = r(e, ...f);
        return o && a(o, e);
      };
      return s(void 0), (e) => s(e instanceof Element ? () => u(e) : void 0);
    }, [r, n]),
    n
  );
  return [t, d];
};
export {
  R as default
};
